export enum FilteringErrorCodes {
    MIN_GREATER_THAN_MAX = 'MIN_GREATER_THAN_MAX',
    EXCEED_MIN_ALLOWED  = ' EXCEED_MIN_ALLOWED',
    EXCEED_MAX_ALLOWED  = ' EXCEED_MAX_ALLOWED',
    EXCEED_LENGTH_CHARTS = ' EXCEED_LENGTH_CHARTS'
}
